import type { CommentResponse, CompanyResponse, ListResponse, ProfileResponse } from '@shared/schemas';

import api from '@/shared/api/api-client';

import type { ListDetailQueryGateway } from './list-detail-query';

/**
 * Real implementation over the shared api client; the single place that knows
 * the shared list-detail read endpoints (kept 1:1 with the original pages). The
 * backend scopes/guards by role, so both detail slices bind this same
 * implementation (the admin http gateway spreads it). `api.get` unwraps the
 * `{ success, data }` envelope.
 */
export const httpListDetailQueryGateway: ListDetailQueryGateway = {
  loadList: (listId) => api.get<ListResponse>(`/lists/${listId}`),

  loadProfiles: (listId) => api.get<ProfileResponse[]>(`/profiles?list_id=${listId}&limit=5000`),

  loadCompanies: (listId) => api.get<CompanyResponse[]>(`/companies?list_id=${listId}`),

  loadCommentCount: async (listId) => {
    const comments = await api.get<CommentResponse[]>(`/comments?list_id=${listId}`);
    return comments.length;
  },
};
